<template>
  <div id="app">
    <NavBar :current-section="currentSection" @navigate="scrollToSection" />
    <ScrollDots :current-section="currentSection" :total="sections.length" @navigate="scrollToSection" />

    <div class="scroll-container" ref="scrollContainer" @scroll="onScroll">
<!--      seo 크롤링 검색 엔진에 잡히게 세팅-->
      <h1 style="position:absolute; left:-9999px;">
        프리미엄 핸드메이드 디퓨저 브랜드 퍼퓸위즈
      </h1>

      <p style="position:absolute; left:-9999px;">
        Perfume Wiz는 향료 고함량으로 제작된 프리미엄 핸드메이드 디퓨저 브랜드입니다.
        화이트머스크와 블랙체리 향을 중심으로 공간을 향기로 채우는 200ml 디퓨저를 제작합니다.
      </p>
      <HeroSection id="hero" class="section" @scroll-down="scrollToSection(1)" />
      <BrandSection id="brand" class="section" />
      <ProductSection id="products" class="section" />
      <ProcessSection id="process" class="section" />
      <ContactSection id="contact" class="section" />
    </div>
  </div>
</template>

<script>
import NavBar from './components/layout/NavBar.vue'
import ScrollDots from './components/layout/ScrollDots.vue'
import HeroSection from './components/sections/HeroSection.vue'
import BrandSection from './components/sections/BrandSection.vue'
import ProductSection from './components/sections/ProductSection.vue'
import ProcessSection from './components/sections/ProcessSection.vue'
import ContactSection from './components/sections/ContactSection.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    ScrollDots,
    HeroSection,
    BrandSection,
    ProductSection,
    ProcessSection,
    ContactSection
  },
  data() {
    return {
      currentSection: 0,
      sections: ['hero', 'brand', 'products', 'process', 'contact'],
      isScrolling: false
    }
  },
  methods: {
    onScroll() {
      const container = this.$refs.scrollContainer
      if (!container) return
      const scrollTop = container.scrollTop
      const sectionHeight = container.clientHeight
      const index = Math.round(scrollTop / sectionHeight)
      this.currentSection = Math.min(index, this.sections.length - 1)
    },
    scrollToSection(index) {
      const container = this.$refs.scrollContainer
      if (!container) return
      const sectionHeight = container.clientHeight
      container.scrollTo({
        top: index * sectionHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/variables';

#app {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.scroll-container {
  height: 100vh;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: $bp-mobile) {
    scroll-snap-type: none;
  }
}

.section {
  height: 100vh;
  scroll-snap-align: start;
  scroll-snap-stop: always;

  @media (max-width: $bp-mobile) {
    height: 100vh;
    min-height: auto;
    scroll-snap-align: none;
  }
}

#hero {
  @media (max-width: $bp-mobile) {
    height: 100vh;
  }
}
</style>
